module.exports = __webpack_public_path__ + "static/media/AgriX_Logoold.b12b7b4e.png";